var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticStyle:{"z-index":"20001"},attrs:{"value":_vm.overlay,"persistent":"","width":"300"}},[_c('v-card',{staticClass:"pa-5"},[_vm._v(" "+_vm._s(_vm.$t("loading"))+" "),_c('v-progress-linear',{staticClass:"mt-1",attrs:{"height":"5","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }